module.exports = __webpack_public_path__ + "img/1505578684.909ae398.jpg";